import { XMarkIcon } from '@heroicons/react/24/solid'

/**
 * Modal Header Component
 * Empire-themed header with title and optional close button
 *
 * @param {Object} props - Component props
 * @param {string} props.title - Header title
 * @param {Function} props.onClose - Close callback
 * @param {boolean} props.showCloseButton - Show close button
 */
const ModalHeader = ({ title, onClose, showCloseButton }) => {
  return (
    <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
      <h2
        id="modal-title"
        className="text-2xl font-bold text-primary"
      >
        {title}
      </h2>

      {showCloseButton && (
        <button
          onClick={onClose}
          className="p-2 text-gray-400 hover:text-gray-600 transition-colors rounded-lg hover:bg-gray-100"
          aria-label="Close modal"
        >
          <XMarkIcon className="w-6 h-6" />
        </button>
      )}
    </div>
  )
}

export default ModalHeader
